











import Vue from 'vue';
import Component from 'vue-class-component';

export default class App extends Vue {

}

